// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VCurrencyField from 'v-currency-field'
// import { VTextField } from 'vuetify/lib'  //Globally import VTextField

// import './stylus/main.styl'

import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import messages from '@/config/i18n'

import { status, statusColor, courseType, subjectType, formatFullDate, formatShortDate, requestStatus, studentRequestStatus } from './filters'

// Vue.use(Vuetify)
Vue.use(Vuetify, { 
  theme: {
    primary: '#FF6D00', // '#ee44aa',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  //iconfont: 'mdi' // 'md' || 'mdi' || 'fa' || 'fa4'
})
Vue.use(VueI18n)

// Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, { 
  locale: 'th-TH',
  decimalLength: 2,
  autoDecimalMode: false,
  min: null,
  max: null,
  defaultValue: 0,
    valueAsInteger: false,
    allowNegative: true
})

const i18n = new VueI18n({
  locale: 'th',
  messages: messages
})

Vue.config.productionTip = false

Vue.filter('status', status)
Vue.filter('statusColor', statusColor)
Vue.filter('courseType', courseType)
Vue.filter('subjectType', subjectType)
Vue.filter('formatFullDate', formatFullDate)
Vue.filter('formatShortDate', formatShortDate)
Vue.filter('studentRequestStatus', studentRequestStatus)
Vue.filter('requestStatus', requestStatus)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js